<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
import { useMarketingHead } from '@/composables/useMarketingHead';

interface Props {
    /** Page-specific title segment; " | <site name>" is appended automatically. */
    title: string;
    /** Meta description — aim for 140–160 characters. */
    description: string;
    /** Path component (starts with '/'), used for the canonical URL and og:url. */
    path: string;
    /** Optional OG image; defaults to /og/default.png. */
    image?: string;
}

const props = defineProps<Props>();

const head = useMarketingHead({
    title: () => props.title,
    description: () => props.description,
    path: () => props.path,
    image: () => props.image,
});
</script>

<template>
    <Head :title="head.documentTitle">
        <meta name="description" :content="head.description" />
        <link rel="canonical" :href="head.url" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" :content="head.siteName" />
        <meta property="og:url" :content="head.url" />
        <meta property="og:title" :content="head.title" />
        <meta property="og:description" :content="head.description" />
        <meta property="og:image" :content="head.image" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" :content="head.title" />
        <meta name="twitter:description" :content="head.description" />
        <meta name="twitter:image" :content="head.image" />
    </Head>
</template>
